<template>
  <div class="container">
    <form novalidate @submit.prevent="checkLocalLogin">
      <HeadingOne class="-margin-md">ログイン</HeadingOne>

      <ErrorsAlert :errors="errors" :items="inputItemsCe"></ErrorsAlert>

      <p>
        ご登録いただいたログインID（メールアドレス）とパスワードを入力してください。
      </p>

      <section>
        <TableGroup>
          <TableBox>
            <TableBody>
              <TableRow>
                <TableHeader class="-entry"
                  >ログインID<small
                    >（メールアドレス）<small class="moji"
                      >【半角英数】</small
                    ></small
                  ></TableHeader
                >
                <TableData
                  :has-error="errors['local_id'] || errors['local_id_login']"
                >
                  <InputGroup
                    :errors="errors"
                    :prop-names="['local_id', 'local_id_login']"
                  >
                    <InputgroupAppend>
                      <InputItem
                        id="local_id"
                        v-model="loginData.local_id"
                        class="-md"
                        :maxlength="50"
                      ></InputItem>
                    </InputgroupAppend>
                    <InputLabel id="abc"> 入力例：****@au.com </InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader class="-entry"
                  >ログインパスワード<small class="moji"
                    >【半角英数8文字以上】</small
                  ></TableHeader
                >
                <TableData
                  :has-error="
                    errors['local_id_passwd'] || errors['local_id_login']
                  "
                >
                  <InputGroup
                    :errors="errors"
                    :prop-names="['local_id_passwd', 'local_id_login']"
                  >
                    <InputgroupAppend>
                      <InputItem
                        id="local_id_passwd"
                        v-model="loginData.local_id_passwd"
                        class="-md"
                        :maxlength="25"
                        type="password"
                      ></InputItem>
                    </InputgroupAppend>
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
          </TableBox>
        </TableGroup>
      </section>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-main" @click.prevent="checkLocalLogin">
          ログイン
        </BtnMain>
      </BtngroupSingle>

      <p>
        ログインID（メールアドレス）を登録されていない場合や、お忘れの場合は<BtnText
          router-name="ce003"
          class="-underline"
          >こちら</BtnText
        >より設定してください。
      </p>
    </form>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import { initCredentials } from "@/utils/Auth";
import { localIdLogin } from "@/utils/LocalLoginHelper";
import { inputItemsCe } from "@/constants/constant";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import HeadingOne from "@/components/heading/HeadingOne";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import InputGroup from "@/components/input/InputGroup";
import InputItem from "@/components/input/InputItem";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import InputLabel from "@/components/input/InputLabel";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import BtnText from "@/components/button/BtnText";

export default {
  name: "Ce002",
  components: {
    BtnText,
    ErrorsAlert,
    BtnMain,
    BtngroupSingle,
    InputLabel,
    InputgroupAppend,
    InputItem,
    InputGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "ログイン",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ローカルID,認証方法",
    });
  },
  data() {
    return {
      errors: {},
      isDisabled: false,
      loginData: {
        local_id: "",
        local_id_passwd: "",
      },
      inputItemsCe: inputItemsCe,
    };
  },
  methods: {
    checkLocalLogin() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        initCredentials()
          .then(() => {
            localIdLogin(this.loginData)
              .then((res) => {
                this.errors = res.result.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  window.$cookies.set(
                    "user_session",
                    res.result.user_session,
                    "15min",
                    "/",
                    null,
                    process.env.VUE_APP_COOKIES_SECURE
                  );

                  switch (res.result.redirect_page) {
                    case "EN-022-0":
                      return this.$router.push({
                        name: "en022",
                        query: { state: "0" },
                      });
                    case "EN-022-1":
                      return this.$router.push({
                        name: "en022",
                        query: { state: "1" },
                      });
                    case "EN-022-2":
                      return this.$router.push({
                        name: "en022",
                        query: { state: "2" },
                      });
                  }
                  let pageId = res.result.redirect_page
                    .replace("-", "")
                    .toLowerCase();
                  this.$router.push({ name: pageId });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>
<style scoped></style>
